// extracted by mini-css-extract-plugin
export default {"error-container":"DeleteFeedbackModal_error-container__CJoeH"};